import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'quotation-objective-component', templateUrl: './quotation-objective.component.html', styleUrls: ['./quotation-objective.component.scss'],
    standalone: false
})
export class BuyerCreateQuotationObjectiveComponent {
    private fb = inject(FormBuilder);

    public objectiveFormGroup = this.fb.group({
        isPurchase: [true, [Validators.required]]
    });

    get isOrcamento() {
        var formValue = this.objectiveFormGroup.value;
        return !formValue.isPurchase;
    }
}
